import { render, staticRenderFns } from "./BtnClose.vue?vue&type=template&id=0193e356"
var script = {}
import style0 from "./BtnClose.vue?vue&type=style&index=0&id=0193e356&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports